import { render, staticRenderFns } from "./VaroantDialog.vue?vue&type=template&id=857b12ca&scoped=true&"
import script from "./VaroantDialog.vue?vue&type=script&lang=js&"
export * from "./VaroantDialog.vue?vue&type=script&lang=js&"
import style0 from "./VaroantDialog.vue?vue&type=style&index=0&id=857b12ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857b12ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('857b12ca')) {
      api.createRecord('857b12ca', component.options)
    } else {
      api.reload('857b12ca', component.options)
    }
    module.hot.accept("./VaroantDialog.vue?vue&type=template&id=857b12ca&scoped=true&", function () {
      api.rerender('857b12ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recommend/components/VaroantDialog.vue"
export default component.exports